/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import Overlay from "../Overlay/Overlay.jsx";
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import {motion} from "motion/react";
import {Util} from "../../Utilities.js";
import {FileDrop} from "../DragAndDrop/FileDrop.jsx";

/**
 * This Component Displays a Avatar
 * @example        <UserAvatar firstName={this.props.userAttributes.firstName} surname={this.props.userAttributes.surname} size={"large"} displayStatus={true} status={"online"}/>
 */
class UserAvatar extends React.PureComponent {

    constructor() {
        super();

        this.state = {
            imageURL: "",
            imageKey: ""
        }

    }


    componentDidUpdate(prevProps, prevState, snapshot) {

    }


    componentDidMount() {
    }


    displayAvatar(size, letterColor, textSize, firstLetter, secondLetter, notificationIcon) {


        return (
            <div className="inline-block relative select-none ">
                <span
                    className={`inline-flex items-center justify-center ${size}  rounded-full bg-linear-to-r ${letterColor}`}>
                     <span
                         className={`${textSize} text-center font-medium leading-none text-white`}>{firstLetter}{secondLetter}</span>
                </span>
                {notificationIcon}

            </div>)


    }

    render() {

        let firstLetter = this.props.firstName.charAt(0).toUpperCase()
        let secondLetter = this.props.surname.charAt(0).toUpperCase()

        let letterIndex = (firstLetter.charCodeAt(0) - 65) + (secondLetter.charCodeAt(0) - 65)

        // Avatar background gradient
        let letterColor;
        if (letterIndex < 2) {
            letterColor = "from-green-400 to-blue-500";
        } else if (letterIndex < 4) {
            letterColor = "from-purple-400 via-pink-500 to-red-500";
        } else if (letterIndex < 6) {
            letterColor = "from-indigo-500 via-indigo-700 to-purple-900";
        } else if (letterIndex < 8) {
            letterColor = "from-pink-400 to-yellow-300";
        } else if (letterIndex < 10) {
            letterColor = "from-teal-400 to-indigo-600";
        } else if (letterIndex < 12) {
            letterColor = "from-purple-800 to-green-400";
        } else if (letterIndex < 14) {
            letterColor = "from-orange-500 to-red-600";
        } else if (letterIndex < 16) {
            letterColor = "from-blue-600 to-teal-500";
        } else if (letterIndex < 18) {
            letterColor = "from-yellow-400 to-pink-500";
        } else if (letterIndex < 20) {
            letterColor = "from-red-400 to-purple-600";
        } else if (letterIndex < 22) {
            letterColor = "from-cyan-400 to-blue-600";
        } else if (letterIndex < 24) {
            letterColor = "from-lime-500 to-teal-400";
        } else if (letterIndex < 26) {
            letterColor = "from-blue-500 to-violet-600";
        } else if (letterIndex < 28) {
            letterColor = "from-yellow-600 to-orange-500";
        } else if (letterIndex < 30) {
            letterColor = "from-indigo-600 to-pink-700";
        } else if (letterIndex < 32) {
            letterColor = "from-green-600 to-yellow-400";
        } else if (letterIndex < 34) {
            letterColor = "from-fuchsia-500 to-indigo-400";
        } else if (letterIndex < 36) {
            letterColor = "from-teal-500 to-gray-600";
        } else if (letterIndex < 38) {
            letterColor = "from-red-500 to-amber-400";
        } else if (letterIndex < 40) {
            letterColor = "from-rose-500 to-orange-600";
        } else if (letterIndex < 44) {
            letterColor = "from-yellow-500 to-teal-600";
        } else {
            letterColor = "from-pink-400 to-cyan-500";
        }

        // Avatar Size
        let size;
        // Notification Icon Size
        let notificationIconSize;
        // text size
        let textSize = "text-sm"
        if (this.props.size === "small") {
            textSize = "text-xs"
            size = "size-6!"
            notificationIconSize = "size-1.5!"

        } else if (this.props.size === "normal") {
            size = "size-8!"
            notificationIconSize = "size-2!"

        } else if (this.props.size === "large") {
            size = "size-10!"
            notificationIconSize = "size-2.5!"

        } else if (this.props.size === "extraLarge") {
            size = "size-14!"
            notificationIconSize = "size-3.5!"

        } else if (this.props.size === "full") {
            size = "size-32!"
            notificationIconSize = "size-7!"
            textSize = "text-6xl"
        }
        // Notification Icon
        let notificationIcon = ""
        if (this.props.displayStatus) {
            if (this.props.status === "unknown") {
                notificationIcon = <span
                    className={"absolute bottom-0 right-0 block " + notificationIconSize + " rounded-full ring-2 ring-white bg-gray-300"}/>
            } else if (this.props.status === "online") {
                notificationIcon = <span
                    className={"absolute bottom-0 right-0 block " + notificationIconSize + " rounded-full ring-2 ring-white bg-green-400"}/>
            } else if (this.props.status === "busy") {
                notificationIcon = <span
                    className={"absolute bottom-0 right-0 block " + notificationIconSize + " rounded-full ring-2 ring-white bg-red-400"}/>
            }
        }


        if (this.props.allowEdit) {
            return (
                <FileDrop
                    className={"w-full h-full"}
                    draggingOverFrameClassName={"w-full h-full ring-3 animate-pulse rounded-full"}
                    onDrop={async (files, event) => {
                        let file = files[0]
                        await this.swapImage(file)
                    }}
                >
                    <Overlay overlay={<>
                        <motion.div
                            whileTap={{backgroundColor: "rgba(255 255 255, 0.2)"}}
                            onClick={async () => {
                                let files = await Util.files.openFileDialog()

                                await this.swapImage(files?.[0])

                            }}
                            className={"w-full h-full hover:bg-stone-600/40 cursor-pointer flex justify-center items-center group"}>
                            <DisplayIcon iconName={"IoCamera"}
                                         className={"text-white size-12! opacity-0 group-hover:opacity-100"}/>

                        </motion.div>


                    </>} className=" overflow-hidden rounded-full">
                        {this.displayAvatar(size, letterColor, textSize, firstLetter, secondLetter, notificationIcon)}

                    </Overlay>
                </FileDrop>)

        }


        return this.displayAvatar(size, letterColor, textSize, firstLetter, secondLetter, notificationIcon)
    };
}

export default UserAvatar;

UserAvatar.propTypes = {
    /**
     * The firstName
     * @default Max
     */
    firstName: PropTypes.string,
    /**
     * The surname
     * @default Mustermann
     */
    surname: PropTypes.string,
    /**
     * The size of the Avatar
     * @example large
     * @default normal
     */
    size: PropTypes.oneOf(['small', 'normal', 'large', 'extraLarge', 'full']),
    /**
     * Display status icon
     * @default false
     */
    displayStatus: PropTypes.bool,
    allowEdit: PropTypes.bool,
    /**
     * The current status state
     * @example busy
     * @default online
     */
    status: PropTypes.oneOf(['unknown', 'online', 'busy']),


}

UserAvatar.defaultProps = {
    firstName: 'Max',
    surname: 'Mustermann',
    size: 'normal',
    status: 'unknown',
    displayStatus: false,
    allowEdit: false,

}